<template>
  <div class="p-homepage-collection-carousel">
    <div class="l-container">
      <h2 class="p-homepage-collection-carousel__title t-heading-3 u-margin-bottom-x-small">
        {{ title }}
      </h2>
      <p
        v-if="subtitle"
        class="p-homepage-collection-carousel__subtitle t-paragraph-large u-margin-bottom-medium"
      >
        {{ subtitle }}
      </p>
      <div class="p-homepage-collection-carousel__filter l-flex">
        <template v-for="ringWidth in ringWidths">
          <div
            :key="ringWidth"
            class="p-homepage-collection-carousel__width u-margin-bottom-x-large"
            @click="width = ringWidth"
          >
            <ring-width
              :width="ringWidth"
              :active="width"
            />
          </div>
        </template>
      </div>
      <collection-carousel
        :key="width"
        :collections="filteredCollections"
        class="u-margin-bottom-x-large"
      />
      <btn
        v-if="cta"
        v-bind="cta"
      >
        {{ cta.text }}
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/button/Btn";
import CollectionCarousel from "@/components/carousel/CollectionCarousel";
import RingWidth from "@/components/ringWidth/RingWidth";

/**
   * wrap the stateless HomepageFeaturedRings component in a stateful context
   */
export default {
  components: {
    Btn,
    CollectionCarousel,
    RingWidth
  },
  props: {
    collectionsData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    collections: {
      type: Array,
      default: () => []
    },
    cta: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      width: 'Standard',
      widthOrder: [
        'Wide',
        'Standard',
        'Thin',
        'Halo',
        'Stackable',
        'Accent',
      ]
    }
  },
  computed: {
    filteredCollections() {
      //make sure vue is aware of which properties need a subscription
      const collections = this.collectionsData;
      const width = this.width;
      let result = [];

      for(let collection of collections) {
        let collectionFilled = false;
        let tempProduct = {};
        let availableColors = 0;
        for(let product of collection.products) {
          if (product.metafieldsMap.width) {
            if (product.metafieldsMap.width.value == width) {
              availableColors = availableColors + 1;
              if (collectionFilled == false) {
                tempProduct.availableColors = 12;
                tempProduct.hoverImage = product.hoverImage.src;
                tempProduct.hoverImageAlt = product.hoverImage.alt;
                tempProduct.image = product.featuredImage.src;
                tempProduct.imageAlt = product.featuredImage.alt;
                tempProduct.originalPrice = product.variants[0].compareAtPrice;
                tempProduct.price = product.variants[0].price;
                tempProduct.title = product.metafieldsMap.collection_label ? product.metafieldsMap.collection_label.value.replace('Silicone Ring', '').replace('Classic', '').replace('Contour', '') : '';
                tempProduct.url = "/products/" + product.handle;

                collectionFilled = true;
              }
            }
          }
        }
        if (collectionFilled == true) {
          tempProduct.availableColors = availableColors;
          result.push(tempProduct);
        }

      }
      return result;
    },
    ringWidths() {
      const collections = this.collectionsData;
      let widths = [];
      let reorderedWidths = [];

      for(let collection of collections) {
        for(let product of collection.products) {
          // make sure width exists in the metadata
          if (product.metafieldsMap.width) {
            // check to see if the width has already been captured before adding it
            if (!widths.includes(product.metafieldsMap.width.value)) {
              widths.push(product.metafieldsMap.width.value)
            }
          }
        }
      }

      for(let i = 0; i < this.widthOrder.length; i++) {
        for(let j = 0; j < widths.length; j++) {
          if(widths[j] == this.widthOrder[i]) {
            reorderedWidths.push(widths[j]);
            j = widths.length;
          }
        }
      }
      return reorderedWidths;
    }
  }
}
</script>

<style lang="scss" scoped>
  .p-homepage-collection-carousel {
    padding: $section-padding;
    text-align: center;

    &__title {
      max-width: rem(600px);
      margin: auto;
    }

    &__subtitle {
      max-width: rem(385px);
      margin: auto;
    }

    &__width {
      &:not(:last-child) {
        margin-right: rem(50px);
      }

      @include respond(phone) {
        &:not(:last-child) {
          margin-right: rem(30px);
        }
      }
    }
  }
</style>
